export default function ResultPanel({ result, onRestart }) {

  if (!result) return null;

  return (
    <div className="text-center p-10 space-y-4">
      <h1 className="text-3xl mb-4">Focus Result</h1>

      <h2 className="text-2xl">
        Accuracy: {result.accuracy}%
      </h2>

      <p>Correct Categories: {result.correct} / {result.total}</p>

      <div className="mt-6">
        <h3 className="text-xl mb-2">Actual Counts:</h3>
        <p>Red Rectangles: {result.realCounts?.rectangle}</p>
        <p>Green Circles: {result.realCounts?.circle}</p>
        <p>Blue Triangles: {result.realCounts?.triangle}</p>
      </div>

      <button
        onClick={onRestart}
        className="bg-blue-600 text-white px-6 py-2 mt-6"
      >
        Restart
      </button>
    </div>
  );
}
